import React from 'react';
import {
    Link
} from 'react-router-dom';
import SidebarNavigation from './SidebarNavigation'
import constants from '../ndbk-constants'
import {connect} from 'react-redux'
import Utils from './Utils'

class Notifications extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            notifs:[],
            current: undefined,
            showLoadMore: true,
        }
    }

    componentWillMount() {
        document.title = 'Notifications - ' + constants.WEBSITE_TITLE
        this.fetchNotifications()

    }

    seeNotifications = () => {
        this.props.clearNotifications()
        fetch(`https://${constants.SERVER_IP}/api/notifications/see`, {
                method: 'PUT',
                credentials: 'include',
            })
    }

    fetchNotifications = () => {
        if (this.state.notifs.length===0) {
            fetch(`https://${constants.SERVER_IP}/api/notifications`, {
                    method: 'GET',
                    credentials: 'include',
                })
                .then((response) => response.json())
                .then((response) => {
                    if (response.success) {
                        const notifications = response.data.map((value, index) => {
                            return(
                                {...value, selected : false, time : new Date(value.time)}
                            )
                        })
                        this.setState({showLoadMore: !response.isNotFull, notifs: notifications})
                        this.seeNotifications();
                    }
                    return response.success
                })
                .catch((error) => {
                        console.error(error);
                });
        } else {
            fetch(`https://${constants.SERVER_IP}/api/notifications/from_id/${this.state.notifs[this.state.notifs.length-1].id}`, {
                method: 'GET',
                credentials: 'include',
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    const notifications = response.data.map((value, index) => {
                        return(
                            {...value, selected : false, time : new Date(value.time)}
                        )
                    })
                    this.setState({showLoadMore: !response.isNotFull,  notifs: [...this.state.notifs, ...notifications]})
                }
                return response.success
            })
            .catch((error) => {
                    console.error(error);
            });
        }
    }

    generateDiff = (ndbk, diff) => {

        var summary = <p>Summary: <br/>
                                {diff.nodes.created.length>0?`${diff.nodes.created.length} node(s) created<br/>`:null}
                                {diff.nodes.updated.length>0?`${diff.nodes.updated.length} node(s) updated<br/>`:null},
                                {diff.nodes.deleted.length>0?`${diff.nodes.deleted.length} node(s) removed<br/>`:null},

                                {diff.links.created.length>0?`${diff.links.created.length} link(s) created<br/>`:null},
                                {diff.links.updated.length>0?`${diff.links.updated.length} link(s) updated<br/>`:null},
                                {diff.links.deleted.length>0?`${diff.links.deleted.length} link(s) removed<br/>`:null},
                            </p>

        // ---------------------------------------------------------------------

        var nodesCreated = diff.nodes.created.map(
            node => <li>
                        <Link to={`/nodebook/${ndbk}?nodes=${node.id}`} key={node.id}>{node.title}</Link>
                    </li>
        )

        var nodesUpdated = diff.nodes.updated.map(
            node => <li>
                        <Link to={`/nodebook/${ndbk}?nodes=${node.id}`} key={node.id}>{node.title}</Link>
                        <ul>
                            {
                                node.changes.map(
                                    change => <li key={change.name}>{change.name}: "{change.from}" => "{change.to}"</li>
                                )
                            }
                        </ul>
                    </li>
        )

        var nodesDeleted = diff.nodes.deleted.map(
            node => <li key={node}>{node}</li>
        )

        var nodeChanges =
        <ul>
            <li>Nodes created: <ul>{nodesCreated}</ul></li>
            <li>Nodes updated: <ul>{nodesUpdated}</ul></li>
            <li>Nodes deleted: <ul>{nodesDeleted}</ul></li>
        </ul>

        // ---------------------------------------------------------------------

        var linksCreated = <Link to={`/nodebook/${ndbk}/?links=${diff.links.created.toString()}`}>Links created</Link>

        var linksUpdated = diff.links.updated.map(
            link => <li>
                        <Link to={`/nodebook/${ndbk}/?links=${link.id}`}>Link #{link.id}</Link>
                        <ul>
                            <li>"{link.from}" => "{link.to}"</li>
                        </ul>
                    </li>
        )

        var linksChanges =
        <ul>
            <li>Links created: {linksCreated}</li>
            <li>Links updated: <ul>{linksUpdated}</ul></li>
            <li>Links deleted: {diff.links.delete.toString()}</li>
        </ul>

        // ---------------------------------------------------------------------

        return  <div>
                    {summary}
                    {nodeChanges}
                    {linksChanges}
                </div>
    }

    generateNotifInfo = (c) => {
        //var extra = null
        var info = null
        switch (c.type) {
            //alert user that they were followed
            case 'newcomment' :
                info = (c)
                    ? <span className="notifications-list-item-content-text">{c.first_name} {c.last_name} <Link to={`/user/${c.user}`} >{c.user}</Link> has replied in nodebook <Link to={c.url} >{c.title}</Link></span>
                    : null
                break;
            case 'alertfollow':
            //backend done
                info =  (c)
                    ? <span className="notifications-list-item-content-text">{c.first_name} {c.last_name} <Link to={`/user/${c.user}`} >{c.user}</Link> is now following you.</span>
                    : null
                break;
            // ljude koje ti followujes sta su uradili
            case 'usermake':
            //backend done
                info =  (c.ndbk)
                    ? <span className="notifications-list-item-content-text"><Link to={`/user/${c.user}`} >{c.user}</Link> created a new nodebook <Link to={`/nodebook/${c.ndbk.id}`} >{c.ndbk.title}</Link></span>
                    : null
                break;
            case 'ndbk-compare':
            //backend done
                info =  (c.ndbk)
                    ? <span className="notifications-list-item-content-text"><Link to={`/user/${c.user}`} >{c.user}</Link> proposed changes to nodebook <Link to={`/nodebook/${c.ndbk.id}/compare/${c.ndbk.clone_id}`}>{c.ndbk.title}</Link></span>
                    : null
                break;
            case 'ndbk-user-added':
            //backend done
                info =  (c.ndbk)
                    ? <span className="notifications-list-item-content-text">You have been added to nodebook <Link to={`/nodebook/${c.ndbk.id}`} >{c.ndbk.title}</Link></span>
                    : null
                break;
            case 'userupdate':
            //backend done
                info =  (c.ndbk)
                    ? <span className="notifications-list-item-content-text"><Link to={`/user/${c.user}`}>{c.user}</Link> updated their nodebook <Link to={`/nodebook/${c.ndbk.id}`} >{c.ndbk.title}</Link></span>
                    : null
                //extra = null // TODO
                break;
            case 'userlike':
                info =  (c.ndbk)
                    ? <span className="notifications-list-item-content-text"><Link to={`/user/${c.user}`} >{c.user}</Link> liked <Link to={`/nodebook/${c.ndbk.id}`} >{c.ndbk.title}</Link></span>
                    : null
                break;
            case 'userfollow':
            //backend done
                info =  (c.author)
                    ? <span className="notifications-list-item-content-text"><Link to={`/user/${c.user}`} >{c.user}</Link> is now following user <Link to={`/user/${c.author.username}`} >{c.author.username}</Link></span>
                    : null
                break;
            case 'userfollowgroup':
            //backend done
                info =  (c.group)
                    ? <span className="notifications-list-item-content-text"><Link to={`/user/${c.user}`} >{c.user}</Link> started following group <Link to={`/group/${c.group.id}`} >{c.group.name}</Link></span>
                    : null
                break;
            case 'userfollownodebook':
            //backend done
                info =  (c.nodebook)
                    ? <span className="notifications-list-item-content-text"><Link to={`/user/${c.user}`} >{c.user}</Link> started following nodebook <Link to={`/nodebook/${c.nodebook.id}`} >{c.nodebook.title}</Link></span>
                    : null
                break;
            case 'userjoin':
            //backend done
                info =  (c.group)
                    ? <span className="notifications-list-item-content-text"><Link to={`/user/${c.user}`} >{c.user}</Link> joined group <Link to={`/group/${c.group.id}`} >{c.group.name}</Link></span>
                    : null
                break;
            case 'userjoinorg':
            //backend done
                info =  (c.org)
                    ? <span className="notifications-list-item-content-text"><Link to={`/user/${c.user}`} >{c.user}</Link> joined organization <Link to={`/organization/${c.org.id}`} >{c.org.name}</Link> organization</span>
                    : null
                break;
            case 'usermention':
            //backend done
                info =  (c.ndbk)
                    ? <span className="notifications-list-item-content-text">You have been mentioned in nodebook <Link to={c.ndbk.url} >{c.ndbk.title}</Link></span>
                    : null
                break;
            // radnje grupe
            case 'groupmake':
            //backend done
                info =  (c.ndbk && c.group)
                    ? <span className="notifications-list-item-content-text"><Link to={`/group/${c.group.id}`} >{c.group.name}</Link> created a new nodebook <Link to={`/nodebook/${c.ndbk.id}`} >{c.ndbk.title}</Link></span>
                    : null
                break;
            case 'groupupdate':
            //backend done
                info =  (c.ndbk && c.group)
                    ? <span className="notifications-list-item-content-text"><Link to={`/group/${c.group.id}`} >{c.group.name}</Link> updated <Link to={`/nodebook/${c.ndbk.id}`} >{c.ndbk.title}</Link></span>
                    : null
                //extra = null // TODO
                break;

            // ostale izmene
            case 'ndbkupdate':
                info = (c.ndbk)
                    ? <span className="notifications-list-item-content-text">New version for nodebook <Link to={`/nodebook/${c.ndbk.id}`} >{c.ndbk.title}</Link></span>
                    : null
                //extra = null // TODO
                break;

            case 'queryupdate':
                info =  (c.ndbk && c.query)
                    ? <span className="notifications-list-item-content-text">New changes to <Link to={`/nodebook/${c.ndbk.id}`} >{c.ndbk.title}</Link> for <Link to={`/nodebook/${c.ndbk.id}/?query=${c.query.id}`} >{c.query.name}</Link> query</span>
                    : null
                //extra = null // TODO
                break;
            default:
                info = <span className="notifications-list-item-content-text">
                        Unrecognized notification. {JSON.stringify(c)}
                        </span>
                break;
        }

        return info
    }

    setNotifsStatus = (notifsIds, status) => {
        fetch(`https://${constants.SERVER_IP}/api/notifications/setstatus`, {
                method: (status==='delete'?'DELETE':'POST'),
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ids: notifsIds,
                    status: status
                })
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    if ('delete'===status) {
                        var _undeleted = []
                        this.state.notifs.forEach(
                            n=>{
                                if (notifsIds.indexOf(n.id) === -1) {
                                    _undeleted.push(n)
                                }
                        })
                        this.setState({notifs: _undeleted})
                    } else {
                        this.state.notifs.forEach(
                        n=>{
                            if (notifsIds.indexOf(n.id) !== -1) {
                                n.status = status
                            }
                        })
                        this.setState({notifs: this.state.notifs})
                    }


                }
                return response.success
            })
            .catch((error) => {
                    console.error(error);
            });
    }

    markSelectedAs = (status) => {
        var selected = []
        this.state.notifs.forEach(n=>{if(n.selected && n.status!==status) selected.push(n.id)})
        this.setNotifsStatus(selected, status)
    }

    deleteOne = (notif) => {
        this.setNotifsStatus([notif.id], 'delete')
    }

    toggleFav = (notif) => {
        this.setNotifsStatus([notif.id], notif.status==='unread'?'read':'unread')
    }

    parseTime = (timestamp) => {
        const months =['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
        return `${months[timestamp.getMonth()]} ${timestamp.getDate()}, ${timestamp.getHours()}:${timestamp.getMinutes()<10?'0'+timestamp.getMinutes():timestamp.getMinutes()}`
    }


    render() {
        return (
            <div className="main">

                <SidebarNavigation {...this.props}/>

                <div className="main-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <h2>Notifications</h2>
                            </div>
                        </div>
                        {/*<div className="row">
                            <div className="col-lg-12">
                                <div className="notifications-controls">
                                    Select:&nbsp;
                                        <span className="clicky" onClick={()=>{this.state.notifs.forEach(n=>n.selected=true); this.setState({ notifs: this.state.notifs})}}>[ All ]</span>
                                        <span className="clicky" onClick={()=>{this.state.notifs.forEach(n=>n.selected=false); this.setState({ notifs: this.state.notifs})}}>[ None ]</span>
                                        <span className="clicky" onClick={()=>{this.state.notifs.forEach(n=>n.selected=(n.status==='read')); this.setState({ notifs: this.state.notifs})}}>[ Read ]</span>
                                        <span className="clicky" onClick={()=>{this.state.notifs.forEach(n=>n.selected=(n.status==='unread')); this.setState({ notifs: this.state.notifs})}}>[ Unread ]</span> <br/>
                                    Selected:
                                        <span className="clicky" onClick={()=>{this.markSelectedAs('read')}}>[ &#128366; Mark as read ]</span>
                                        <span className="clicky" onClick={()=>{this.markSelectedAs('unread')}}>[ &#9993; Mark as unread ]</span>
                                        <span className="clicky" onClick={()=>{this.markSelectedAs('delete')}}>[ &#128465; Delete ]</span> <br/>

                                    <span className="clicky" onClick={()=>{this.state.notifs=[]; this.fetchNotifications()}}>[ &#8635; Refresh ]</span> <br/>
                                    <span className="clicky" onClick={()=>{
                                        var unread = []
                                        this.state.notifs.forEach(n=>{if(n.status==='unread') unread.push(n.id)})
                                        this.setNotifsStatus(unread, 'read')
                                    }}>[ Mark all as read ]</span> <br/>
                                </div>
                            </div>
                        </div>*/}

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="notifications-list">
                                {
                                    this.state.notifs.map(
                                        notif => (
                                            <div key={notif.id} className='notifications-list-item'>
                                                <div className="notifications-list-item-content">
                                                    {/*<span className="checkbox" onClick={()=>{notif.selected=!notif.selected; this.setState({notifs: this.state.notifs})}}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                            {
                                                                (notif.selected)
                                                                    ? <path d="M10.041 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591zm-5.041-15"/>
                                                                    : null
                                                            }
                                                            <path d="M5 2c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-14c0-1.654-1.346-3-3-3h-14zm19 3v14c0 2.761-2.238 5-5 5h-14c-2.762 0-5-2.239-5-5v-14c0-2.761 2.238-5 5-5h14c2.762 0 5 2.239 5 5z"/>
                                                        </svg>
                                                    </span>*/}
                                                    <span className="fav" onClick={()=>{this.toggleFav(notif)}}>
                                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                                            <path fill={notif.status!=='read'?'#cacaca':'#92138a'} d="M15.5 19c-0.082 0-0.164-0.020-0.239-0.061l-5.261-2.869-5.261 2.869c-0.168 0.092-0.373 0.079-0.529-0.032s-0.235-0.301-0.203-0.49l0.958-5.746-3.818-3.818c-0.132-0.132-0.18-0.328-0.123-0.506s0.209-0.31 0.394-0.341l5.749-0.958 2.386-4.772c0.085-0.169 0.258-0.276 0.447-0.276s0.363 0.107 0.447 0.276l2.386 4.772 5.749 0.958c0.185 0.031 0.337 0.162 0.394 0.341s0.010 0.374-0.123 0.506l-3.818 3.818 0.958 5.746c0.031 0.189-0.048 0.379-0.203 0.49-0.086 0.061-0.188 0.093-0.29 0.093zM10 15c0.082 0 0.165 0.020 0.239 0.061l4.599 2.508-0.831-4.987c-0.027-0.159 0.025-0.322 0.14-0.436l3.313-3.313-5.042-0.84c-0.158-0.026-0.293-0.127-0.365-0.27l-2.053-4.106-2.053 4.106c-0.072 0.143-0.207 0.243-0.365 0.27l-5.042 0.84 3.313 3.313c0.114 0.114 0.166 0.276 0.14 0.436l-0.831 4.987 4.599-2.508c0.075-0.041 0.157-0.061 0.239-0.061z"></path>
                                                        </svg>
                                                    </span>
                                                    {this.generateNotifInfo(notif.content)}
                                                </div>
                                                <div className="notifications-list-item-date" title={Utils.parseTime(notif.time, 'M D, Y h:m')}>
                                                    {
                                                        //Utils.parseTime(notif.time, 'M D, Y h:m')
                                                        Utils.parseTimeDiff(notif.time)
                                                        }
                                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" onClick={()=>{this.deleteOne(notif)}} title="Remove">
                                                        <path d="M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z"></path>
                                                    </svg>
                                                </div>
                                            </div>)
                                    )
                                }
                                </div>

                                {
                                    this.state.showLoadMore
                                        ? (
                                            <div className="notifications-load" onClick={this.fetchNotifications}>
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                                    <path d="M2.49 4.49c1.605-1.605 3.74-2.49 6.010-2.49s4.405 0.884 6.010 2.49 2.49 3.74 2.49 6.010v1.293l2.146-2.146c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-3 3c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146l-3-3c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l2.146 2.146v-1.293c0-4.136-3.364-7.5-7.5-7.5s-7.5 3.364-7.5 7.5c0 4.136 3.364 7.5 7.5 7.5 0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-2.27 0-4.405-0.884-6.010-2.49s-2.49-3.74-2.49-6.010c0-2.27 0.884-4.405 2.49-6.010z"></path>
                                                </svg>
                                                Load more
                                            </div>
                                        )
                                        : (
                                            <div className="notifications-load disabled">
                                                No more to load
                                            </div>
                                        )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return { messages: state.messages, notifications:state.notifications }
}

function mapDispatchToProps(dispatch) {
    return {
        clearNotifications: ()=>{dispatch({type:'CLEAR_NOTIFICATIONS'})},
        incrementNotifications: (count)=>{ console.log(count) ; dispatch({type:'INCREMENT_NOTIFICATIONS', count:count})},
        decrementNotifications: (count)=>{ console.log(count); dispatch({type:'DECREMENT_NOTIFICATIONS', count:count})},
    }
}

export default connect( mapStateToProps, mapDispatchToProps)(Notifications)

//export default Notifications;



// WEBPACK FOOTER //
// ./src/components/NotificationsPage.js